module.exports = __webpack_public_path__ + "img/fuel-station-pump.416bdd9a.svg";